/*global jQuery, Slideout, viewport*/
(function ($) {
    'use strict';

    var $expandSubmenuBtn   = $('nav#navigation .navigation__cta'),
        $megamenuWrapper    = $('nav#megamenu'),
        $searchMobileExpand = $('a#header__search-icon'),
        $searchMobileForm   = $('div#header__search-mobile'),
        $searchMobileInput  = $('input#header__search-input'),
        $skipLink           = $('div#top a[href="#navigation"]'),
        $navFirstFocusable  = $('nav#navigation :focusable'),
        $nav                = $('nav#navigation'),
        slideout,
        slideOptions = {
            'panel':     document.getElementById('page-wrapper'),
            'menu':      document.getElementById('navigation'),
            'padding':   268,
            'side':     'right',
            'tolerance': 200,
            'touch':     false
        };
    
    switch (viewport.getType()) {
    case 'global':
        slideOptions.padding = 268;
        break;
    case 'medium':
        slideOptions.padding = 320;
        break;
    case 'wide':
        slideOptions.padding = 320;
        break;
    default:
        slideOptions.padding = 268;
    }
    
    if ($nav.length) {

        // slideout.js plugin call
        $.slideoutInst = slideout = new Slideout(slideOptions);

        // Toggle menu on skip link
        $skipLink.on('click', function (e) {
            e.preventDefault();

            slideout.toggle();
            $navFirstFocusable
                .first()
                .focus();

        });

        // Toggle search on mobile
        $searchMobileExpand.on('click', function (e) {
            e.preventDefault();

            $searchMobileForm
                .slideToggle('fast')
                .toggleClass('header__search-mobile--active');
            $searchMobileInput
                .focus();

        });

        // accessible mega menu plugin call
        $megamenuWrapper.accessibleMegaMenu({
            // prefix for generated unique id attributes
            uuidPrefix: "accessible-megamenu",

            // css class used to define the megamenu styling
            menuClass: "megamenu__list",

            // css class for a top-level navigation item in the megamenu
            topNavItemClass: "megamenu__item",

            // css class for a megamenu panel
            panelClass: "megamenu__sub-nav",

            // css class for a group of items within a megamenu panel
            panelGroupClass: "megamenu__sub-group",

            // css class for the hover state
            hoverClass: "hover",

            // css class for the focus state
            focusClass: "focus",

            // css class for the open state
            openClass: "megamenu__link--open"
        });
    }
}(jQuery));